<ng-container *transloco="let t; read: 'home.calculator'">
  <div *ngIf="solarCalculatorResult" @inOutAnimation class="flex flex-col gap-10 items-stretch">

    <psc-solar-assessment
      [solarCalculatorResult]="solarCalculatorResult"></psc-solar-assessment>
    <psc-yearly-chart
      class=" mb-10"
      [solarCalculatorResult]="solarCalculatorResult"></psc-yearly-chart>

    <psc-yearly-savings
      [powerPlant]="powerPlant"
      [extendedData]="true"
      [solarCalculatorResult]="solarCalculatorResult"></psc-yearly-savings>

    <psc-return-on-investment-chart
      [solarCalculatorResult]="solarCalculatorResult"></psc-return-on-investment-chart>

    <psc-peak-power-chart
      [solarCalculatorResult]="solarCalculatorResult"></psc-peak-power-chart>

    <psc-user-investment
      [solarCalculatorResult]="solarCalculatorResult"></psc-user-investment>

    <psc-yearly-spendings
      *ngIf="solarCalculatorResult.country === PriceCountry.HR"
      [solarCalculatorResult]="yearlySpending"
      [currency]="solarCalculatorResult.currency"></psc-yearly-spendings>
  </div>

  <div class="grid gap-10 mt-10">
    <div>
      <psc-section-title
        [title]="t('calculator.monthly_result')"
        alignment="left"
        size="normal"
        [lineWidthPercentage]="100"
        [lineThickness]="2"></psc-section-title>

      <psc-month-selector
        class="block w-full"
        [solarCalculatorResult]="solarCalculatorResult"
        (monthChanged)="selectedMonth = $event"></psc-month-selector>

      <psc-monthly-values
        [showDebt]="true"
        [showTitle]="false"
        [selectedMonth]="selectedMonth"
        [solarCalculatorResult]="solarCalculatorResult"></psc-monthly-values>
    </div>
  </div>

</ng-container>
